import type { ElementType } from "react";
import {
  Archive,
  Bell,
  Circle,
  FileText,
  Inbox,
  MailOpen,
  ShieldAlert,
  Sparkles,
  WalletCards,
} from "lucide-react";
import type {
  NotificationCategory,
  NotificationSeverity,
  NotificationStatusFilter,
} from "@/lib/notification.api";

export const PAGE_SIZE = 8;
export const ALL_FILTER_VALUE = "__all__";

export type AllFilterValue = typeof ALL_FILTER_VALUE;

export const CATEGORY_LABELS: Record<NotificationCategory, string> = {
  system: "Système",
  documents: "Documents",
  finance: "Finance",
  stock: "Stock",
  commission: "Commissions",
  savings: "Épargne",
};

export const SEVERITY_LABELS: Record<NotificationSeverity, string> = {
  info: "Information",
  success: "Succès",
  warning: "Attention",
  danger: "Critique",
};

export const SEVERITY_CLASSES: Record<NotificationSeverity, string> = {
  info: "border-info-border bg-info-bg text-info-text",
  success: "border-success-border bg-success-bg text-success-text",
  warning: "border-warning-border bg-warning-bg text-warning-text",
  danger: "border-danger-border bg-danger-bg text-danger-text",
};

export const CATEGORY_ICONS: Record<NotificationCategory, ElementType> = {
  system: Bell,
  documents: FileText,
  finance: ShieldAlert,
  stock: Archive,
  commission: Sparkles,
  savings: WalletCards,
};

export interface InboxBucket {
  value: NotificationStatusFilter;
  label: string;
  icon: ElementType;
}

export const INBOX_BUCKETS: InboxBucket[] = [
  { value: "unread", label: "Non lues", icon: Circle },
  { value: "all", label: "Toutes", icon: Inbox },
  { value: "read", label: "Lues", icon: MailOpen },
  { value: "archived", label: "Archivées", icon: Archive },
];
